import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { PremiumMonthlyInfo } from '@cms-max/medicare-api-sdk'
import { Card, InfoCircleIcon } from '@cmsgov/ds-medicare-gov'
import { Divider } from 'components/Divider/Divider'
import { MyTooltip } from 'components/MyTooltip'

import classes from './CurrentMonthlyPremiumCard.module.scss'

type CurrentMonthlyPremiumCardProps = {
  monthlyPremium: PremiumMonthlyInfo
}
export function CurrentMonthlyPremiumCard ({ monthlyPremium }: CurrentMonthlyPremiumCardProps) {
  const { t } = useTranslation('premiumsMonthly', { keyPrefix: 'currentPremiumCard' })
  const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

  const total = formatter.format(monthlyPremium.total)
  const monthString = (new Date(monthlyPremium.date.year, monthlyPremium.date.month - 1, 15)).toLocaleString('en-US', { month: 'long', year: 'numeric' })

  return (
    <Card className="ds-u-padding--3">
      <div>
        <div className='ds-u-margin-bottom--1'>{t('currentPremium')}</div>
        <div className="ds-text-body--lg"><strong>{t('overall', { amount: total, month: monthString })}</strong></div>
      </div>
      <Divider className='ds-u-margin-y--2' />
      <div>
        <div className='ds-u-margin-bottom--1'>{t('premiumBreakdown')}</div>
        <table className={classNames('ds-u-text-align--left', classes.table)}>
          <tbody>
          <tr>
            <th>{t('table.partBAmount')}</th>
            <td>{formatter.format(monthlyPremium.partB.amount)}</td>
          </tr>
          <tr>
            <th>{t('table.partBLateEnrollmentPenalty')}</th>
            <td>{formatter.format(monthlyPremium.partB.lateEnrollmentPenalty)}</td>
          </tr>
          <tr>
            <th>{t('table.partBIrmaa')}</th>
            <td>{formatter.format(monthlyPremium.partB.irmaaAmount)}</td>
          </tr>
          <tr>
            <th>{t('table.maPartB')}
            <MyTooltip aria-label={t('table.maPartBAriaLabel')} placement="bottom" title={t('table.maPartBToolTip')} className='ds-c-tooltip__trigger-icon my-u-color--medicare-green'>
              <span className="my-c-circle-icon-tooltip"><InfoCircleIcon/></span>
            </MyTooltip></th>
            <td>{formatter.format(monthlyPremium.partB.maPlanPayment)}</td>
          </tr>
          <tr>
            <th>{t('table.partAAmount')}</th>
            <td>{formatter.format(monthlyPremium.partA.amount)}</td>
          </tr>
          <tr>
            <th>{t('table.partALateEnrollmentPenalty')}</th>
            <td>{formatter.format(monthlyPremium.partA.lateEnrollmentPenalty)}</td>
          </tr>
          <tr>
            <th>{t('table.partDIrmaa')}</th>
            <td>{formatter.format(monthlyPremium.partD.irmaaAmount)}</td>
          </tr>
          </tbody>
          <tfoot>
            <tr>
              <th>{t('table.total')}</th>
              <td>{formatter.format(monthlyPremium.total)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </Card>
  )
}

export default CurrentMonthlyPremiumCard
